export const downloadCSVFile = (res, fileName) => {
    const url = window.URL.createObjectURL(new Blob([res]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${fileName}.csv`)
    document.body.appendChild(link)
    link.click()
    link.remove()
}

export const addCommas = (numberString) => {
    return numberString && numberString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const BADGE_TYPE_LABELS = {
    PEERTOPEER: 'On-The-Spot',
    NOMINATED: 'Nominated',
    AUTOMATED: 'Milestones',
};

/**
 * Label shown to employees explaining a badge's grouping. Uses the admin-set
 * category; when that is empty or "Default", falls back to the recognition type.
 */
export const getBadgeCategoryLabel = (badge) => {
    const category = badge?.category?.trim();
    if (category && category.toLowerCase() !== 'default') return category;
    const typeCode = badge?.badgeTypeCode || badge?.badgeType;
    return BADGE_TYPE_LABELS[typeCode] || null;
}

// Milestone/automated recognitions are not sent by a person. Their `awardedBy`
// holds a sentinel such as "Automated", "Automated (Manual)" or
// "Automated (Backfill)" instead of a user id.
export const isAutomatedRecognizer = (awardedBy) =>
	typeof awardedBy === 'string' &&
	awardedBy.trim().toLowerCase().startsWith('automated');

// Historical milestones awarded after the fact. They keep their points and
// certificate, but their pin/gift rewards are never claimable.
export const isBackfilledAssignment = (assignment) =>
	typeof assignment?.awardedBy === 'string' &&
	assignment.awardedBy.trim().toLowerCase() === 'automated (backfill)';

// Display name of whoever sent a recognition. Automated recognitions are
// attributed to the company. Returns '' when no name is available.
export const getRecognizerName = (awardedBy, awardedByUser, companyName) => {
	if (isAutomatedRecognizer(awardedBy)) return companyName || '';
	return [awardedByUser?.firstName, awardedByUser?.lastName]
		.filter(Boolean)
		.join(' ');
};
